import { Box, Card, Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { appUrl, vimeoClientId } from "../../common/api/config";
import vimeoLogo from "../../common/assets/img/platform_logos/vimeo.webp";
import Button from "../../common/components/Button";
import { SPACING } from "../../common/constants/spacing";
import { requestAccessTokenFromVimeo } from "../api/vimeo";

const openVimeoOAuthPopup = () => {
  const redirectUri = `${appUrl}/vimeo-oauth-callback`;

  const scope = "public private";
  const state = "vimeo-oauth";
  const oauthUrl = `https://api.vimeo.com/oauth/authorize?client_id=${vimeoClientId}&redirect_uri=${encodeURIComponent(
    redirectUri,
  )}&response_type=code&scope=${encodeURIComponent(scope)}&state=${state}`;

  const width = 500;
  const height = 600;
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;

  window.open(
    oauthUrl,
    "VimeoOAuth",
    `width=${width},height=${height},top=${top},left=${left}`,
  );
};

export const LinkVimeoCard = ({ createSource }) => {
  const { t } = useTranslation("sources");

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data?.source === "vimeo-oauth" && event.data.code) {
        const authCode = event.data.code;
        const tokenData = await requestAccessTokenFromVimeo(authCode);
        let tokenExpiresAt = null;
        if (tokenData.expires_in) {
          const expiresAt = Date.now() + tokenData.expires_in * 1000;
          tokenExpiresAt = new Date(expiresAt).toISOString();
        }

        const source = {
          platform: "vimeo",
          access_token: tokenData.access_token,
          refresh_token: tokenData.refresh_token,
          token_expires_at: tokenExpiresAt,
          channel_id: (tokenData.user?.uri || "").split("/").pop(),
          account_name: tokenData.user?.name || "",
        };
        try {
          await createSource(source);
        } catch (error) {
          console.error("Error creating data source:", error);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid size={{ xs: 12, md: 4 }}>
      <Card variant="outlined" sx={{ p: 3, height: "100%", mt: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          <Box>
            <img
              src={vimeoLogo}
              alt="Vimeo Logo"
              style={{
                height: "70px",
                paddingTop: 15,
                paddingBottom: 15,
                objectFit: "contain",
                marginBottom: 10,
              }}
            />
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: SPACING.xs }}
            >
              Vimeo
            </Typography>
            <Typography variant="bodySm" sx={{ color: "text.secondary" }}>
              {t("platforms.vimeo.description")}
            </Typography>
          </Box>

          <Button
            variant="outlined"
            sx={{ mt: 3 }}
            onClick={openVimeoOAuthPopup}
            fullWidth
          >
            {t("platforms.vimeo.buttonText")}
          </Button>
        </Box>
      </Card>
    </Grid>
  );
};
